// TODO: See if keywords can be put here

import { useDispatch, useSelector } from "react-redux";
import ModalCloseButton from "./ModalCloseButton";
import { setActiveProject } from "../../store";

function Modal() {
  const dispatch = useDispatch();
  const { activeProject, projectData } = useSelector((state) => state.app);

  const activeProjectData = projectData[activeProject];

  const onClose = () => {
    dispatch(setActiveProject(null));
  };

  // const keywordsList = activeProjectData.keywords.map((keyword, index) => [
  //   index > 0 && ", ",
  //   <a
  //     href={`https://www.google.com/search?q=${keyword.toLowerCase()}`}
  //     target="_blank"
  //     className="project-keyword underline"
  //     rel="noreferrer"
  //     key={index}
  //   >
  //     {keyword}
  //   </a>,
  // ]);

  const skillsList = activeProjectData.skills.map((skill) => (
    <div
      key={skill}
      className="h-4 px-1 mr-2 my-1 font-medium skill-label text-[0.6rem] text-black min-w-[25px] w-max flex flex-col justify-center items-center"
    >
      {skill}
    </div>
  ));

  return (
    <div
      className="w-[95vw] h-[80vh] max-w-[370px] top-[75px] left-0 right-0 mx-auto absolute pl-expanded-modal overflow-hidden flex flex-col text-white"
      onClick={(e) => e.stopPropagation()}
    >
      <div className="bg-black h-[30%] w-full select-none overflow-hidden">
        <img
          src={activeProjectData.img}
          alt={activeProjectData.title}
          className="w-full h-full object-cover"
        />
      </div>
      <div className="px-2 w-full h-[70%] flex flex-col pb-1.5 items-center">
        <div className="text-4xl font-medium my-2 text-center">
          {activeProjectData.title}
        </div>
        <div className="text-xs">
          <span className="text-yellow">{activeProjectData.date}</span> @{" "}
          <span className="text-red">{activeProjectData.createdAt}</span>
        </div>
        {/* <div className="text-xs mt-1 text-center">{keywordsList}</div> */}
        <div className="flex flex-row my-1 max-w-[90%] flex-wrap">
          {skillsList}
        </div>
        <div className="grow w-full overflow-y-auto pb-2 whitespace-pre-wrap">
          <p>{activeProjectData.longDesc}</p>
          <div className="mt-5">
            <p>
              This project is available at:{" "}
              <a
                href={activeProjectData.externalLink}
                target="_blank"
                className="underline cyan-text yellow-text-active active:no-underline"
                rel="noreferrer"
              >
                &lt;project-link&gt;
              </a>
              .
            </p>
          </div>
        </div>
        <div className="w-full h-9 mt-1 flex flex-col items-center justify-center">
          <ModalCloseButton onClick={onClose} className="w-max" />
        </div>
      </div>
    </div>
  );
}

export default Modal;
